import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: ${({ theme }) => theme.spacing.medium};
  // padding: 1.5rem 2rem;
  padding: 1.5rem;

  @media screen and (max-width: 1100px) {
    overflow-y: scroll;
    padding: 1.5rem 1.25rem;
  }
`;

export const NameBlock = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 1023px) {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing.medium};
    align-items: start;
  }
`;

export const InnerNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.medium};

  @media screen and (max-width: 520px) {
    align-items: end;
  }
`;

export const Path = styled.div`
  display: flex;
  gap: 6px;
  font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  color: ${({ theme }) => theme.colors.mediumGrey};
  text-transform: uppercase;
  text-wrap: nowrap;

  @media screen and (max-width: 520px) {
    flex-direction: column;
  }
`;

export const ActivePath = styled.span`
  margin: 0;
  padding: 0;
  font-weight: ${({ theme }) => theme.typography.h2.fontWeight};
  font-size: ${({ theme }) => theme.typography.h2.fontSize};
  color: ${({ theme }) => theme.colors.textSecondary};
  text-transform: uppercase;
`;

export const Spinner = styled.div`
  display: flex;
  justify-self: center;
  align-self: center;
  margin: auto;
`;

export const EmptyMessage = styled.div`
  padding-top: ${({ theme }) => theme.padding.medium};
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const ChartsFlex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.medium};
  height: 100%;
  overflow: hidden;

  @media screen and (max-width: 1100px) {
    flex-direction: column;
    overflow: visible;
    height: auto;
  }
`;

export const CalculatedChart = styled.div<{ $isFullScale: boolean }>`
  display: flex;
  flex: ${({ $isFullScale }) => ($isFullScale ? "2" : "1")};
  height: 100%;
`;

export const WellChart = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  position: relative;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.borderColor};
  align-items: stretch;
  justify-content: stretch;

  svg {
    width: 100%;
    height: 100%;
  }

  p {
    margin: auto;
    text-align: center;
    font-size: 1rem;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.mediumGrey};
  }

  @media screen and (max-width: 1100px) {
    min-height: 900px;
  }
`;

export const OuterChartsFlex = styled.div<{
  $hasStepScrollDots: boolean;
  $isVisible: boolean;
}>`
  display: flex;
  flex: ${({ $isVisible }) => ($isVisible ? "4" : "1")};
  gap: ${({ $hasStepScrollDots }) => ($hasStepScrollDots ? "7px" : "20px")};

  @media screen and (max-width: 1100px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
  }
`;

export const LogCharts = styled.div<{
  $isVisible: boolean;
}>`
  display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
  flex: 3;
  overflow-y: hidden;
  height: 100%;

  @media screen and (max-width: 1100px) {
    overflow-y: visible;
    flex: 1;
    height: auto;
  }
`;

export const PumpScheduleBlock = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  // flex: 1 1 300px;
  min-height: 300px;
`;

export const WidgetActionButton = styled.span<{ $right?: string }>`
  position: absolute;
  top: 0.25rem;
  right: ${({ $right }) => $right ?? "0.5rem"};
  z-index: 3;
  color: ${({ theme }) => theme.colors.mediumGrey};
  cursor: pointer;
  padding: 0.5rem;

  :hover {
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const ControlsPanel = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};

  .p-multiselect {
    min-width: 5rem;
  }

  .p-inputtext {
    padding: 0.35rem 0.45rem !important;
  }
  .p-multiselect:not(.p-disabled):hover {
    .p-multiselect-trigger {
      color: ${({ theme }) => theme.colors.iconHover};
    }
  }
  .p-multiselect-trigger {
    color: ${({ theme }) => theme.colors.iconSecondary};
    transition: background-color 0.2s, color 0.2s, border-color 0.2s,
      box-shadow 0.2s;
  }
  .p-multiselect .p-multiselect-label {
    padding: 0.45rem 0.65rem;
  }

  .p-multiselect .p-multiselect-label.p-placeholder {
    color: ${({ theme }) => theme.colors.textSecondary};
  }

  @media screen and (max-width: 1023px) {
    width: 100%;
    justify-content: end;
  }
`;

export const RealtimeCards = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};

  @media screen and (max-width: 1450px) {
    gap: 5px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  }

  @media screen and (max-width: 520px) {
    display: flex;
    flex-direction: column;
  }
`;
